import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {StoreContext} from "../../store.context";
import {TranslationDomainEnum} from "../../types/enums";
import {TranslationOutlined} from "@ant-design/icons";
import {Space} from "antd";

export const Translate: React.FC<{
    message: string,
    params?: { [key: string]: string },
    domain?: TranslationDomainEnum,
    raw?: boolean
}> = observer(({ message, params = {}, domain = TranslationDomainEnum.MESSAGES , raw = false}) => {
    const { appStore: {
        translations,
        translatorMode,
        findTranslationForEditMode,
        translate
    } } = useContext(StoreContext);

    function createMarkup(message: any) {
        return {__html: message};
    }

    if (!translations[domain]?.hasOwnProperty(message)) {
        if (raw) {
            return <div dangerouslySetInnerHTML={createMarkup(message)} />;
        }

        return <span>{message}</span>;
    }

    return (
        <Space>
            {translatorMode && (
                <TranslationOutlined style={{ color: 'red', zIndex: 1 }} onClick={async (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    await findTranslationForEditMode(domain, message);
                }} />
            ) }
            {raw ? (<div dangerouslySetInnerHTML={createMarkup(translate(translations[domain][message], params))}/>) :
                    (<span>{translate(translations[domain][message], params)}</span>)
            }

        </Space>
    );
});